export default __webpack_public_path__ + "static/media/order-recipeguide-icon.a76dcf56.svg";